<div class="expand-card w-100">
    <div class="pointer" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px" (click)="toggle()">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" class="t-button-small">
            <ng-content select="[expandCardIcon]"></ng-content>
            <span class=" c-primary-gray-900">{{ title }}</span>
        </div>
        <ui-kit-svg name="ic_arrow_up" class="i-16 expand-card-chevron" [class.collapsed]="!expanded"></ui-kit-svg>
    </div>
    @if (expanded) {
        <div class="bc-mono-white radius-10 p-12 mt-16">
            <ng-content></ng-content>
        </div>
    }
</div>
